import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {Allegato, IntegrazioneIstanzaAllDTO} from "../../models/integrazione";
import {TributiService} from "../../services/tributi.service";
import {ActivatedRoute, Router} from "@angular/router";
import {AlertService} from "../../shared/alert/alert.service";
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";
import {zonedTimeToUtc} from "date-fns-tz";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import { Istanza, IstanzaDTO } from '../../models/istanza';
import {IstanzaService} from "../../services/istanza.service";
import { format, parse } from 'date-fns';
import { MessageService } from '../../services/message.service';

@Component({
  selector: 'jhi-integrazione',
  templateUrl: './integrazione-pagamenti.component.html',
  styleUrls: ['./integrazione-pagamenti.component.scss'],
})
export class IntegrazionePagamentiComponent extends SubscriptionManager implements OnInit {
  listaIstanzeAllegato: Array<Allegato>;
  listaAllegati: Array<Allegato>;
  idIstanza: string;
  loading: boolean;
  maxSize: number;
  width: number;
  curIndex: number;
  id: string;
  istanzaCorrente?: IstanzaDTO;
  istanzaService: IstanzaService;
  mapStatiPagamento: Map<string, { testo: string; colore: string }>;
  @ViewChild('_MD_ALLEGATO') _md_allegato!: ElementRef;
  selectedLanguage: string = this.translateService.currentLang;

  constructor(
    private messageService: MessageService,
    private tributiService: TributiService,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    istanzaService: IstanzaService
  ) {
    super();
    this.loading = true;
    this.idIstanza = this.activatedRoute.snapshot.paramMap.get('idIstanza') ?? '';
    this.listaIstanzeAllegato = [];
    this.listaAllegati = [];
    this.maxSize = 52428800;
    this.width = window.innerWidth;
    this.curIndex = 0;
    this.istanzaService = istanzaService;
    this.id = this.activatedRoute.snapshot.params.idIstanza;
    this.mapStatiPagamento = new Map([
      ['00', { testo: 'Da pagare', colore: 'red' }],
      ['01', { testo: 'Pagato', colore: 'green' }],
      ['10', { testo: 'Annullato', colore: 'orange' }],
    ]);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent): void {
    this.width = (event.target as Window).innerWidth;
  }

  ngOnInit(): void {
    this.subs.sink = this.istanzaService.getDatiIstanza(this.id).subscribe({
      next: res => {
        this.loading = false;
        this.istanzaCorrente = res;
      },
      error: () => {
        void this.router.navigate(['error']);
      },
      complete: () => {
        this.loading = false;
      },
    });
    this.subs.sink = this.translateService.onLangChange.subscribe((langChangeEvent: LangChangeEvent) => {
      this.selectedLanguage = langChangeEvent.lang;
    });
  }

  goBack(): void {
    if (window.history.state.previousRoute) {
      void this.router.navigate([window.history.state.previousRoute]);
    } else {
      void this.router.navigate(['Servizi/IstanzeEmesse']);
    }
  }

  formatDate(date: string | undefined): Date {
    return zonedTimeToUtc(parse(date ? date : '', 'yyyy-MM-dd', new Date()), 'Europe/Rome');
  }
  formatDateNormal(date: Date): string {
    return format(new Date(date), 'dd/MM/yyyy');
  }

  goToPagamento(istanza: Istanza | undefined, idpagamento: number): void {
    this.loading = true;
    this.subs.sink = this.tributiService.getIntegrazione(<string>istanza?.id).subscribe({
      next: res => {
        const pagamentoSelezionato = res.pagamento.find((x: { id: number; })  =>  x.id === idpagamento);
        this.messageService.sendPagamento({
          integrazione: res.integrazione,
          pagamento: pagamentoSelezionato,
          descrizione: <string>istanza?.descrizione,
          cdServizio: istanza?.servizio.cdServizio ? istanza.servizio.cdServizio : '',
          flPagamento: <boolean>istanza?.servizio.flPagamento
        });
        void this.router.navigate(['Servizi/PagamentoIstanza'], { state: { previousRoute: 'Servizi/IstanzeEmesse' } });
      },
      error: err => {
        this.loading = false;
        this.alertService.creaAlert(err.error.messaggio, 'danger', 'sticky', 3000, true);
      },
      complete: () => {
        this.loading = false;
      },
    });
  }
  scaricaAvviso(avvisoPagopa: string | null): void {
    if (avvisoPagopa != null) {
      const byteCharacters = atob(avvisoPagopa);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = 'avvisoPagoPa.pdf';
      link.click();

      URL.revokeObjectURL(url);
    }
  }
}
